<nz-layout>
    <nz-spin [nzSpinning]="isLoading">
        <nz-header class="flex flex-row items-center flex-wrap h-fit !pb-2">
            <!-- first header row -->
            <div class="w-full flex flex-row justify-between items-center">
                <div class="flex flex-row items-center gap-4 justify-start">
                    <button nz-button nzType="link" (click)="closeDrawer()">
                        <i class="fa-solid fa-x"></i>
                    </button>
                    <span
                        class="text-base font-bold cursor-pointer"
                        nz-tooltip="Copy link"
                        (click)="copyCurrentUrlToClipboard()"
                        >Order #{{ orderId }}
                    </span>
                    <button
                        nz-button
                        nzType="default"
                        (click)="switchOrder('previous')"
                    >
                        <i class="fa fa-chevron-left"></i>
                    </button>
                    <button
                        nz-button
                        nzType="default"
                        (click)="switchOrder('next')"
                    >
                        <i class="fa fa-chevron-right"></i>
                    </button>
                    <span class="text-sm text-gray-500">
                        Created: {{ order?.createdAt | date : 'medium' }}
                    </span>
                </div>

                <div
                    class="flex flex-row items-center gap-4 justify-end ml-auto"
                >
                    <nz-tag *ngIf="order?.trackingLink || order?.trackingCode">
                        <a
                            (click)="openTrackingLink()"
                            nz-tooltip="Track Order"
                        >
                            Track
                            <i class="fas fa-external-link"></i>
                        </a>
                    </nz-tag>
                    <nz-tag
                        *ngIf="
                            order?.meta?.paymentId ||
                            (order?.payment?.gateway === 'stripe' &&
                                order?.payment?.paymentId) ||
                            (order?.invoices?.length
                                ? order?.invoices[0]?.id
                                : null) as paymentId
                        "
                    >
                        <a
                            (click)="openStripe(paymentId)"
                            nz-tooltip="Open in Stripe"
                        >
                            Stripe
                            <i class="fas fa-external-link"></i>
                        </a>
                    </nz-tag>
                    <nz-tag>
                        <a
                            (click)="openShipstation(order?.id)"
                            nz-tooltip="Open in Shipstation"
                        >
                            Shipstation
                            <i class="fas fa-external-link"></i>
                        </a>
                    </nz-tag>
                    <nz-tag *ngIf="order?.version !== 2">
                        <a
                            (click)="openBigCommerce('' + order.id)"
                            nz-tooltip="Open in BigCommerce"
                        >
                            BigCommerce
                            <i class="fas fa-external-link"></i>
                        </a>
                    </nz-tag>
                </div>
            </div>
            <!-- end of first header row -->

            <!-- second header row -->
            <div
                class="w-full flex flex-row justify-between items-start gap-4 mt-1"
            >
                <div class="flex flex-row items-center justify-start gap-3">
                    <button
                        nz-button
                        nz-tooltip="Retrigger Current Status"
                        nzType="default"
                        [disabled]="!retriggerStatusAvailable"
                        (click)="retriggerOrderStatus()"
                    >
                        <i class="fa fa-refresh"></i>
                    </button>
                    <nz-select
                        *ngIf="!!order"
                        [ngModel]="order?.status"
                        (ngModelChange)="saveStatus($event)"
                        class="w-[200px]"
                    >
                        <nz-option
                            *ngFor="let status of statusOptions"
                            [nzValue]="status[0]"
                            [nzLabel]="status[1].name"
                        ></nz-option>
                    </nz-select>

                    <!-- Payment Status - Clickable to open modal -->
                    <div *ngIf="order" class="flex items-center">
                        <div
                            class="flex items-center space-x-2 bg-gray-50 rounded-md px-3 py-1 cursor-pointer hover:bg-gray-100 transition-colors"
                            (click)="openPaymentStatusModal()"
                            [nzTooltipTitle]="
                                'Click to manually update payment status'
                            "
                            nz-tooltip
                        >
                            <i
                                *ngIf="paymentStatus"
                                [class]="paymentStatuses[paymentStatus]?.icon"
                                [style.color]="paymentStatusColor"
                                class="text-sm"
                            ></i>
                            <span
                                *ngIf="paymentStatus"
                                [style.color]="paymentStatusColor"
                                class="text-sm font-medium"
                            >
                                {{ paymentStatuses[paymentStatus]?.name }}
                            </span>
                            <span
                                *ngIf="!paymentStatus"
                                class="text-sm font-medium text-gray-500"
                            >
                                No Payment Status
                            </span>
                            <i
                                class="fa-solid fa-pen-to-square text-xs text-gray-400 ml-1"
                            ></i>
                            <!-- Amount display with refund clarity -->
                            <div
                                *ngIf="paymentStatus && paymentDetails"
                                class="flex items-center space-x-1 text-sm ml-2"
                            >
                                <span class="text-gray-600">
                                    {{ paymentDetails?.amount | currency }}
                                </span>
                                <!-- Show refund amount inline for partial refunds -->
                                <span
                                    *ngIf="
                                        paymentDetails?.refundAmount &&
                                        paymentStatus === 'partially_refunded'
                                    "
                                    class="text-red-500 text-xs"
                                >
                                    (-{{
                                        paymentDetails.refundAmount | currency
                                    }})
                                </span>
                            </div>

                            <!-- Failed reason tooltip -->
                            <span
                                *ngIf="paymentDetails?.failedReason"
                                [nzTooltipTitle]="paymentDetails.failedReason"
                                nz-tooltip
                                class="text-red-500 text-xs ml-1"
                            >
                                <i class="fa-solid fa-exclamation-circle"></i>
                            </span>
                        </div>
                    </div>

                    <!-- Delayed Capture Flag -->
                    <div *ngIf="isDelayedCapture" class="flex items-center">
                        <nz-tag
                            nzColor="orange"
                            class="flex items-center gap-1"
                        >
                            <i class="fa-solid fa-clock"></i>
                            Delayed Capture
                        </nz-tag>
                    </div>

                </div>

                <div
                    class="flex flex-row flex-wrap-reverse items-end justify-end gap-4"
                    *ngIf="order?._id"
                >
                    <div class="flex flex-col">
                        <nz-select
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="Assigned User"
                            [ngModel]="assignedTo"
                            (ngModelChange)="saveAssignedTo($event)"
                            class="w-[200px]"
                        >
                            <nz-option
                                *ngFor="let user of adminUsersOptions"
                                [nzLabel]="
                                    user.firstName +
                                    ' ' +
                                    user.lastName +
                                    '(' +
                                    user.role +
                                    ')'
                                "
                                [nzValue]="user._id"
                            ></nz-option>
                        </nz-select>
                        <button
                            nz-button
                            nzType="link"
                            (click)="assignToMe()"
                            nzSize="small"
                            class="text-xs font-bold"
                        >
                            Assign to Me
                        </button>
                    </div>
                    <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Assign to Pharmacy"
                        [ngModel]="assignedPharmacy"
                        (ngModelChange)="saveAssignedPharmacy($event)"
                        class="w-[220px]"
                    >
                        <nz-option
                            *ngFor="let pharmacy of pharmaciesOptions"
                            [nzLabel]="pharmacy.name"
                            [nzValue]="pharmacy._id"
                        ></nz-option>
                    </nz-select>
                    <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Assigned Group"
                        [ngModel]="assignedToGroup"
                        (ngModelChange)="saveAssignedToGroup($event)"
                        class="w-[200px]"
                    >
                        <nz-option-group nzLabel="Group">
                            <nz-option
                                *ngFor="let group of groupsOptions"
                                [nzLabel]="group"
                                [nzValue]="group"
                            ></nz-option>
                        </nz-option-group>
                    </nz-select>
                </div>
            </div>
            <!-- end of second header row -->
        </nz-header>
        <nz-content>
            <!-- Medical Team Contact Alert -->
            <div
                *ngIf="
                    order?.extras?.needsMedicalTeamContact === 'true' ||
                    order?.extras?.needsMedicalTeamContact === true
                "
                class="w-full mb-3 p-2 bg-amber-50 border-l-2 border-red-400 rounded mt-1"
            >
                <div class="flex items-center gap-2">
                    <i
                        class="fa-solid fa-exclamation-circle text-amber-600 text-sm"
                    ></i>
                    <span class="text-amber-800 text-sm font-medium">
                        Medical Team Contact Required
                    </span>
                </div>
            </div>
            <section class="mt-4">
                <portals-emr-customer-summary
                    *ngIf="orderCustomer"
                    [customerId]="orderCustomer?._id"
                    [orderId]="orderId"
                    #customerSummaryRef
                ></portals-emr-customer-summary>
            </section>

            <section *ngIf="order?.extras?.masterId || order?.meta?.masterId">
                <portals-emr-order-visit
                    [orderId]="orderId"
                    [masterId]="order.extras.masterId"
                    (visitCanceled)="onBelugaVisitCanceled()"
                ></portals-emr-order-visit>
            </section>

            <!-- Lab Requisitions -->
            <section *ngIf="order?.status === 'awaiting_requisition'" class="mt-4">
                <div class="flex items-center justify-between mb-1">
                    <div class="flex items-center gap-2">
                        <h5 class="m-0">Lab Requisitions</h5>
                        <a
                            *ngIf="showAllLabReqs"
                            nz-button
                            nzType="default"
                            nzSize="small"
                            class="mt-1"
                            (click)="showAllLabReqs = false"
                        >View less</a>
                    </div>
                    <div
                        *ngIf="order?.status === 'awaiting_requisition'"
                        class="flex items-center gap-2"
                    >
                        <nz-select
                            [(ngModel)]="selectedLabReqTemplate"
                            nzPlaceHolder="Template"
                            style="min-width: 150px"
                        >
                            <nz-option
                                *ngFor="let tmp of labReqTemplates"
                                [nzValue]="tmp"
                                [nzLabel]="tmp.label"
                            ></nz-option>
                        </nz-select>
                        <button
                            nz-button
                            nzType="primary"
                            [disabled]="!selectedLabReqTemplate"
                            (click)="openCreateLabReq()"
                        >
                            Create LabReq
                        </button>
                    </div>
                </div>


                <nz-spin *ngIf="labReqLoading$ | async" nzSimple></nz-spin>

                <ng-container *ngIf="!(labReqLoading$ | async)">
                    <ng-container *ngIf="orderLabReqs$ | async as labReqs">
                        <div
                            *ngIf="labReqs.length === 0"
                            class="text-gray-400 text-sm"
                        >
                            No lab requisitions yet.
                        </div>

                        <nz-table
                            *ngIf="labReqs.length > 0"
                            [nzData]="showAllLabReqs ? labReqs : labReqs.slice(0, 2)"
                            [nzShowPagination]="false"
                            nzSize="small"
                        >
                            <thead>
                                <tr>
                                    <th>Template</th>
                                    <th>Created</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let req of showAllLabReqs ? labReqs : labReqs.slice(0, 2)"
                                >
                                    <td style="text-transform: uppercase; position: relative;">
                                        {{ req.templateId }}
                                        {{ req.templateVariant }}
                                        <span
                                            *ngIf="req._id === justCreatedLabReqId"
                                            style="position: absolute; top: 4px; right: 8px; color: #52c41a; font-size: 10px; text-transform: none; white-space: nowrap;"
                                        >*Just created</span>
                                    </td>
                                    <td>{{ req.createdAt | date: 'mediumDate' }}</td>
                                    <td>
                                        <i
                                            (click)="openViewLabReq(req)"
                                            nz-icon
                                            nzType="eye"
                                            nzTheme="twotone"
                                            [nzTwotoneColor]="'#b97800'"
                                            class="pointer"
                                            nz-tooltip
                                            nzTooltipTitle="View"
                                        ></i>
                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>

                        <a
                            *ngIf="!showAllLabReqs && labReqs.length > 2"
                            nz-button
                            nzType="default"
                            nzSize="small"
                            (click)="showAllLabReqs = true"
                        >Load more</a>
                        <a
                            *ngIf="showAllLabReqs && labReqs.length > 2"
                            nz-button
                            nzType="default"
                            nzSize="small"
                            (click)="showAllLabReqs = false"
                        >View less</a>

                    </ng-container>
                </ng-container>
            </section>

            <nz-modal
                [(nzVisible)]="showMarkCompletedModal"
                nzTitle="Mark order as completed"
                (nzOnCancel)="showMarkCompletedModal = false"
                [nzFooter]="markCompletedFooter"
            >
                <ng-container *nzModalContent>
                    <p>Are you sure you want to mark the order as completed?</p>
                </ng-container>
                <ng-template #markCompletedFooter>
                    <button
                        nz-button
                        nzType="primary"
                        (click)="confirmMarkCompleted()"
                    >Yes</button>
                    <button
                        nz-button
                        nzType="default"
                        (click)="showMarkCompletedModal = false"
                    >No</button>
                </ng-template>
            </nz-modal>

            <section
                *ngIf="
                    activeDigitalSubscriptions.length +
                        activePhysicalSubscriptions.length >
                    0
                "
            >
                <h5>Subscriptions</h5>
                <div class="flex flex-col gap-2">
                    <div class="flex gap-2">
                        <div
                            class="flex items-center gap-2"
                            *ngFor="
                                let subscription of activeDigitalSubscriptions
                            "
                        >
                            <nz-tag
                                class="text-green-400 flex gap-1 items-center cursor-pointer"
                                nz-tooltip="Open Subscription Details"
                                (click)="
                                    openSubscriptionDrawer(subscription._id)
                                "
                            >
                                {{ subscription.product.label }}
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </nz-tag>
                        </div>
                    </div>
                    <div class="flex gap-2">
                        <div
                            class="flex items-center gap-2"
                            *ngFor="
                                let subscription of activePhysicalSubscriptions
                            "
                        >
                            <nz-tag
                                class="text-blue-400 flex gap-1 items-center cursor-pointer"
                                nz-tooltip="Open Subscription Details"
                                (click)="
                                    openSubscriptionDrawer(subscription._id)
                                "
                            >
                                {{ subscription.product.label }}
                                <i class="fa-solid fa-capsules"></i>
                            </nz-tag>
                        </div>
                    </div>
                </div>
            </section>
            <!-- Pharmacy Transfer Indicator -->
            <section *ngIf="isTransferOut">
                <div class="flex items-center gap-2 mb-2">
                    <h5 class="m-0">Pharmacy Transfer</h5>
                    <button
                        nz-button
                        nzType="link"
                        (click)="disableTransferOut()"
                    >
                        Ship Order Instead
                    </button>
                    <button
                        *ngIf="!isPharmacyAddressEditMode"
                        nz-button
                        nzType="link"
                        (click)="enableEditPharmacyAddress()"
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                        Edit Transfer Address
                    </button>
                    <button
                        *ngIf="isPharmacyAddressEditMode"
                        nz-button
                        nzType="link"
                        (click)="disableEditPharmacyAddress()"
                    >
                        <i class="fa-solid fa-x"></i>
                        Cancel
                    </button>
                    <nz-tag
                        *ngIf="isTransferOut"
                        nzColor="orange"
                        class="flex items-center gap-1"
                    >
                        <i class="fa-solid fa-arrow-right-arrow-left"></i>
                        Transfer Out to Pharmacy
                    </nz-tag>
                </div>
                <div
                    *ngIf="pharmacyAddress || isPharmacyAddressEditMode"
                    class="p-4 rounded-md"
                >
                    <ng-container
                        *ngIf="
                            !isPharmacyAddressEditMode;
                            else transferAddressEditTpl
                        "
                    >
                        <div class="font-medium mb-2">
                            {{ pharmacyAddress.name }}
                        </div>
                        <div class="text-sm">
                            <div *ngIf="pharmacyAddress.address1">
                                {{ pharmacyAddress.address1 }}
                            </div>
                            <div *ngIf="pharmacyAddress.address2">
                                {{ pharmacyAddress.address2 }}
                            </div>
                            <div
                                *ngIf="
                                    pharmacyAddress.city ||
                                    pharmacyAddress.provinceCode ||
                                    pharmacyAddress.postalCode
                                "
                            >
                                {{ pharmacyAddress.city
                                }}{{
                                    pharmacyAddress.city &&
                                    (pharmacyAddress.provinceCode ||
                                        pharmacyAddress.postalCode)
                                        ? ', '
                                        : ''
                                }}
                                {{ pharmacyAddress.provinceCode
                                }}{{
                                    pharmacyAddress.provinceCode &&
                                    pharmacyAddress.postalCode
                                        ? ' '
                                        : ''
                                }}
                                {{ pharmacyAddress.postalCode }}
                            </div>
                            <div
                                *ngIf="pharmacyAddress.phoneNumber"
                                class="mt-1"
                            >
                                <i class="fa-solid fa-phone mr-1"></i>
                                {{ pharmacyAddress.phoneNumber }}
                            </div>
                            <div *ngIf="pharmacyAddress.faxNumber" class="mt-1">
                                <i class="fa-solid fa-fax mr-1"></i>
                                {{ pharmacyAddress.faxNumber }}
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div
                    *ngIf="isTransferOut && !pharmacyAddress"
                    class="p-4 bg-yellow-50 rounded-md"
                >
                    <div class="text-yellow-800">
                        <i class="fa-solid fa-exclamation-triangle mr-1"></i>
                        Order will be transferred to
                        {{ pharmacyAddress?.name || 'pharmacy' }}
                    </div>
                </div>
                <ng-template #transferAddressEditTpl>
                    <form
                        nzLayout="vertical"
                        nz-form
                        [formGroup]="pharmacyAddressFG"
                        (ngSubmit)="savePharmacyAddress()"
                    >
                        <div nz-row [nzGutter]="[20, 0]">
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label>Pharmacy Name</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="name"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label>Phone Number</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="phoneNumber"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label>Fax Number</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="faxNumber"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label>Address 1</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="address1"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label>Address 2</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="address2"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="8">
                                <nz-form-item>
                                    <nz-form-label>City</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="city"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="8">
                                <nz-form-item>
                                    <nz-form-label>Province</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="provinceCode"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="8">
                                <nz-form-item>
                                    <nz-form-label>Postal Code</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="postalCode"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label>Country Code</nz-form-label>
                                    <nz-form-control>
                                        <input
                                            nz-input
                                            formControlName="countryCode"
                                        />
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="24" class="text-right">
                                <button
                                    nz-button
                                    nzType="primary"
                                    type="submit"
                                >
                                    Save Transfer Address
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-template>
                <div class="linked-rx-card">
                    <div class="linked-rx-header">
                        <div class="linked-rx-title">Linked Prescription</div>
                        <button
                            *ngIf="
                                !linkedPrescription &&
                                availablePrescriptionsToLink.length > 0
                            "
                            nz-button
                            nzType="primary"
                            nzSize="small"
                            (click)="openLinkPrescriptionModal(false)"
                        >
                            Link RX
                        </button>
                    </div>
                    <div
                        *ngIf="linkedPrescription; else noLinkedRx"
                        class="linked-rx-body"
                    >
                        <div class="linked-rx-main compact">
                            <a
                                class="linked-rx-link"
                                nz-popconfirm
                                nzPopconfirmTitle="This action will count as a print and will increase the print count for this RX?"
                                (nzOnConfirm)="viewLinkedPrescription()"
                            >
                                RX {{ linkedPrescription._id }}
                            </a>
                            <button
                                nz-button
                                nzType="text"
                                nzDanger
                                nzSize="small"
                                class="linked-rx-unlink"
                                (click)="unlinkLinkedPrescription()"
                            >
                                Unlink
                            </button>
                        </div>
                        <div
                            class="linked-rx-subtext"
                            *ngIf="
                                linkedPrescription.transferredOutAt as transferredAt
                            "
                        >
                            Transferred out
                            {{ transferredAt | date : 'MMM d yyyy @ h:mm a' }}
                        </div>
                        <div
                            class="linked-rx-actions"
                            *ngIf="!linkedPrescription.transferredOutAt"
                        >
                            <button
                                nz-button
                                nzType="primary"
                                nzSize="small"
                                (click)="transferLinkedPrescription()"
                            >
                                Transfer RX
                            </button>
                        </div>
                    </div>
                    <ng-template #noLinkedRx>
                        <div class="linked-rx-empty">
                            No linked RX for this order.
                        </div>
                    </ng-template>
                </div>
            </section>

            <!-- Shipping Address (hidden for pharmacy transfers) -->
            <section *ngIf="!isTransferOut">
                <div class="flex items-center">
                    <h5 class="m-0">Shipping Address</h5>
                    <button
                        nz-button
                        nzType="link"
                        nz-tooltip
                        nzTooltipTitle="Replace shipping flow with pharmacy transfer flow"
                        (click)="onTransferToPharmacyClick()"
                    >
                        Transfer to Pharmacy
                    </button>
                    <button
                        *ngIf="!isShippingAddressEditMode"
                        nz-button
                        nzType="link"
                        (click)="enableEditAddress()"
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                        *ngIf="isShippingAddressEditMode"
                        nz-button
                        nzType="link"
                        (click)="disableEditAddress()"
                        Cancel
                    >
                        <i class="fa-solid fa-x"></i>
                    </button>
                </div>
                <div
                    class="flex gap-1 items-baseline"
                    *ngIf="order?.shippingAddress"
                >
                    <ng-container *ngIf="isShippingAddressEditMode">
                        <div class="p-4">
                            <form
                                nzLayout="vertical"
                                nz-form
                                [formGroup]="addressFG"
                                (ngSubmit)="saveAddress()"
                            >
                                <div nz-row [nzGutter]="[20, 0]">
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label
                                                >Street Address</nz-form-label
                                            >
                                            <nz-form-control>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    formControlName="address1"
                                                    placeholder=""
                                                    style="border-radius: 5px"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label
                                                >Street Address 2</nz-form-label
                                            >
                                            <nz-form-control>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    formControlName="address2"
                                                    placeholder=""
                                                    style="border-radius: 5px"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label>City</nz-form-label>
                                            <nz-form-control>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    formControlName="city"
                                                    placeholder=""
                                                    style="border-radius: 5px"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label
                                                >Province Code</nz-form-label
                                            >
                                            <nz-form-control>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    formControlName="provinceCode"
                                                    placeholder=""
                                                    style="border-radius: 5px"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label
                                                >Postal Code</nz-form-label
                                            >
                                            <nz-form-control>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    formControlName="postalCode"
                                                    placeholder=""
                                                    style="border-radius: 5px"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label
                                                >Country Code</nz-form-label
                                            >
                                            <nz-form-control>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    formControlName="countryCode"
                                                    placeholder=""
                                                    style="border-radius: 5px"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>

                                    <div
                                        class="p-2 flex items-center justify-end w-full"
                                    >
                                        <button
                                            nz-button
                                            nzType="primary"
                                            type="submit"
                                        >
                                            <i class="fa-solid fa-check"></i
                                            >&nbsp;Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!isShippingAddressEditMode">
                        <ng-container
                            *ngTemplateOutlet="
                                addressTpl;
                                context: {
                                    $implicit: order.shippingAddress
                                }
                            "
                        ></ng-container>
                    </ng-container>
                </div>
            </section>

            <section>
                <div class="flex">
                    <h5>Products</h5>
                    <button
                        *ngIf="order?.version === 2 && !isProductsEditMode"
                        nz-button
                        nzType="link"
                        (click)="toggleProductsEditMode()"
                        class="ml-2 transition-all duration-200"
                    >
                        <i class="fa-solid mr-1 fa-pen-to-square"></i>
                    </button>
                </div>
                <portals-emr-order-editor
                    #productEditor
                    *ngIf="isProductsEditMode"
                    [order]="order"
                    (productsSave)="onProductsSave($event)"
                    (formValidityChange)="formValidity = $event"
                ></portals-emr-order-editor>

                <!-- Save/Cancel buttons when editing products -->
                <div
                    *ngIf="isProductsEditMode"
                    class="mt-4 flex justify-end gap-2"
                >
                    <button nz-button (click)="cancelProductsEdit()">
                        Cancel
                    </button>
                    <button
                        nz-button
                        nzType="primary"
                        (click)="saveProductsEdit()"
                        [disabled]="!formValidity"
                    >
                        Save Changes
                    </button>
                </div>

                <!-- Order totals -->
                <!-- Nz-table does not display more than 10 without pagination -->
                <nz-table
                    *ngIf="!isProductsEditMode"
                    #productsTable
                    [nzData]="productTableRows"
                    [nzShowPagination]="
                        productTableRows.length > 10 ? true : false
                    "
                    nzPaginationType="small"
                    nzSize="small"
                    [nzNoResult]="'No Products'"
                >
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>
                                {{ orderVersion === 2 ? 'Options' : 'Variant' }}
                            </th>
                            <th>Listed Price</th>
                            <th>Sale Price</th>
                            <th>Qty</th>
                            <th>Total Discount</th>
                            <th>Total Insurance</th>
                            <th>Total Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template
                            ngFor
                            let-row
                            [ngForOf]="productsTable?.data"
                        >
                            <tr
                                [class.no-bottom-border]="
                                    row.prescribingContext
                                "
                            >
                                <td>
                                    <div class="font-medium">
                                        {{ row.lineItem?.name }}
                                    </div>
                                    <div class="text-xs text-gray-500">
                                        {{ row.lineItem?.subLabel }}
                                    </div>
                                    <div class="text-xs text-gray-500">
                                        {{ row.lineItem?.productId }}
                                    </div>
                                </td>
                                <td *ngIf="orderVersion === 2; else variantTpl">
                                    <div
                                        class="flex flex-wrap gap-1 justify-center"
                                    >
                                        <nz-tag
                                            *ngFor="
                                                let option of row.lineItem
                                                    ?.options | keyvalue
                                            "
                                        >
                                            {{ option.key }}: {{ option.value }}
                                        </nz-tag>
                                    </div>
                                </td>
                                <ng-template #variantTpl>
                                    <td *ngIf="row.lineItem?.variantId">
                                        <portals-emr-variant-select
                                            [isEditable]="false"
                                            [productId]="row.lineItem.productId"
                                            [variantId]="
                                                '' + row.lineItem?.variantId
                                            "
                                        ></portals-emr-variant-select>
                                    </td>
                                </ng-template>
                                <td>
                                    {{
                                        row.lineItem?.listPrice ||
                                            row.lineItem?.price ||
                                            0 | currency
                                    }}
                                </td>
                                <td>
                                    {{
                                        row.lineItem?.salePrice ||
                                            row.lineItem?.listPrice ||
                                            0 | currency
                                    }}
                                </td>
                                <td>
                                    {{ row.lineItem?.quantity }}
                                </td>
                                <td>
                                    {{
                                        row.lineItem?.discount?.amount || 0
                                            | currency
                                    }}
                                </td>
                                <td>
                                    {{
                                        row.lineItem?.totalInsuranceAmount || 0
                                            | currency
                                    }}
                                </td>
                                <td>
                                    {{
                                        row.lineItem?.price *
                                            row.lineItem?.quantity || 0
                                            | currency
                                    }}
                                </td>
                                <td>
                                    <button
                                        nz-button
                                        (click)="openRefillDrawer(row.lineItem)"
                                    >
                                        Refill
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="row.prescribingContext as ctx">
                                <td
                                    colspan="9"
                                    class="!pt-0 !pb-2 !px-6 !border-t-0"
                                >
                                    <div class="flex flex-wrap gap-1">
                                        <nz-tag
                                            *ngFor="let row of ctx.items"
                                            class="!text-xs !mb-0 !rounded-full !px-2.5 !py-0.5 !leading-4 !border-gray-200 !bg-gray-50"
                                            [nz-tooltip]="row.hint"
                                        >
                                            <span class="text-gray-400 mr-1">{{
                                                row.label
                                            }}</span>
                                            <span class="font-medium">{{
                                                row.value || '—'
                                            }}</span>
                                        </nz-tag>
                                        <nz-tag
                                            *ngFor="let t of ctx.indicators"
                                            nzColor="orange"
                                            class="!text-xs !mb-0 !rounded-full !px-2.5 !py-0.5 !leading-4"
                                            >{{ t }}</nz-tag
                                        >
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </tbody>
                </nz-table>
                <div class="w-full mt-4 space-y-2 text-right">
                    <div class="flex justify-end items-center">
                        <span class="text-sm font-medium mr-4">Subtotal:</span>
                        <span class="text-sm w-24">{{
                            order?.subTotalAmount | currency
                        }}</span>
                    </div>
                    <div
                        *ngIf="order?.discountAmount > 0"
                        class="flex justify-end items-center"
                    >
                        <span class="text-sm font-medium mr-4"
                            >Total Discounts:</span
                        >
                        <span class="text-sm w-24"
                            >-{{ order?.discountAmount | currency }}</span
                        >
                    </div>
                    <div
                        *ngIf="order?.coupon"
                        class="flex justify-end items-center text-gray-500 text-xs"
                    >
                        <span class="text-right"
                            >(Coupon Code Applied: {{ order?.coupon }})</span
                        >
                    </div>
                    <div
                        *ngIf="order?.totalInsuranceAmount > 0"
                        class="flex justify-end items-center"
                    >
                        <span class="text-sm font-medium mr-4"
                            >Insurance Coverage:</span
                        >
                        <span class="text-sm w-24"
                            >-{{ order?.totalInsuranceAmount | currency }}</span
                        >
                    </div>
                    <div
                        *ngIf="order?.creditUsedAmount > 0"
                        class="flex justify-end items-center"
                    >
                        <span class="text-sm font-medium mr-4"
                            >Credit Used:</span
                        >
                        <span class="text-sm w-24"
                            >-{{ order?.creditUsedAmount | currency }}</span
                        >
                    </div>
                    <div
                        *ngIf="order?.giftCardUsedAmount > 0"
                        class="flex justify-end items-center"
                    >
                        <span class="text-sm font-medium mr-4"
                            >Gift Card Used:</span
                        >
                        <span class="text-sm w-24"
                            >-{{ order?.giftCardUsedAmount | currency }}</span
                        >
                    </div>
                    <div
                        *ngIf="order?.postPurchaseCredit > 0"
                        class="flex justify-end items-center"
                    >
                        <span class="text-sm font-medium mr-4"
                            >Post-Purchase E-Credit:</span
                        >
                        <span class="text-sm text-green-500 w-24"
                            >+{{ order?.postPurchaseCredit | currency }}</span
                        >
                    </div>
                    <div class="flex justify-end items-center">
                        <span class="text-sm font-bold mr-4"
                            >Patient Charged:</span
                        >
                        <span class="text-sm font-bold w-24"
                            >{{ patientChargedAmount | currency }}
                        </span>
                    </div>
                    <div
                        *ngIf="patientDueAmount > 0"
                        class="flex justify-end items-center"
                    >
                        <span class="text-sm font-bold mr-4"
                            >Patient Due:</span
                        >
                        <span class="text-sm font-bold w-24"
                            >{{ patientDueAmount | currency }}
                        </span>
                    </div>
                    <div
                        *ngIf="
                            order?.payment?.status === 'failed' ||
                            order?.payment?.status === 'delayed_capture' ||
                            order?.payment?.status === 'partial_paid' ||
                            order?.payment?.status === 'pending' ||
                            order?.payment?.status === 'voided' ||
                            order?.payment?.status === 'adjudicated' ||
                            (!order?.payment &&
                                ['pending', 'awaiting_payment'].includes(
                                    order?.status
                                ))
                        "
                        class="flex justify-end items-center mt-4"
                    >
                        <button
                            nz-button
                            nzSize="default"
                            nzType="primary"
                            [nzLoading]="isLoading"
                            (click)="chargeOrder()"
                            class="ml-4"
                        >
                            <i class="fa-solid fa-credit-card mr-2"></i>
                            Charge Order
                        </button>
                    </div>
                </div>
            </section>

            <!-- ORDER REQUIREMENTS -->
            <section *ngIf="order?._id">
                <div class="flex justify-between items-center">
                    <div class="flex items-center gap-2">
                        <h5 class="m-0">Requirements</h5>
                        <a
                            nz-button
                            nzType="link"
                            nzSize="small"
                            (click)="openAllConsultationsView()"
                        >
                            <i class="fa-solid fa-list-check"></i>&nbsp;View All
                        </a>
                    </div>
                    <button
                        *ngIf="!isRequirementsEditMode; else reqEditCtrls"
                        nz-button
                        nzType="link"
                        (click)="editRequirements()"
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </button>

                    <ng-template #reqEditCtrls>
                        <div>
                            <button
                                nz-button
                                nzType="link"
                                (click)="isRequirementsEditMode = false"
                                Cancel
                            >
                                <i class="fa-solid fa-x"></i>
                            </button>
                            <button
                                nz-button
                                [nzType]="'primary'"
                                (click)="saveRequirements()"
                            >
                                <i class="fa-solid fa-check"></i>&nbsp;Save
                            </button>
                        </div>
                    </ng-template>
                </div>

                <div>
                    <!-- Order Requirements -->
                    <nz-tag
                        *ngFor="let req of requirements"
                        class=""
                        (click)="onRequirementClick(req)"
                        [nzTooltipTitle]="getReqTooltipTitle(req)"
                        nzTooltipPlacement="bottom"
                        [ngClass]="{
                            'text-red-400':
                                req.status === 'not_satisfied' &&
                                req.qnr?.status !== 'incomplete',
                            'text-gray-400': req.qnr?.status === 'incomplete',
                            'text-green-400':
                                req.status === 'satisfied' &&
                                req.qnr?.status != 'new',
                            'hover:bg-gray-200 cursor-pointer':
                                req.status === 'satisfied' ||
                                req.qnr ||
                                req.type === 'verification',
                            'text-blue-400': req.qnr?.status === 'new'
                        }"
                        nz-tooltip
                        >{{ req.label }}
                        <i
                            class="fa-solid fa-circle-check"
                            *ngIf="req.status === 'satisfied'"
                        ></i>
                        <i
                            class="fa-solid fa-circle-xmark"
                            *ngIf="req.status === 'not_satisfied'"
                        ></i>
                    </nz-tag>

                    <!-- Additional Order Requirements -->
                    <nz-tag
                        *ngFor="let req of additionalReqs; let i = index"
                        (click)="
                            !isRequirementsEditMode
                                ? onRequirementClick(req)
                                : null
                        "
                        [nzTooltipTitle]="getReqTooltipTitle(req)"
                        nzTooltipPlacement="bottom"
                        [ngClass]="{
                            'text-red-400':
                                req.status === 'not_satisfied' &&
                                req.qnr?.status !== 'incomplete',
                            'text-gray-400': req.qnr?.status === 'incomplete',
                            'text-green-400':
                                req.status === 'satisfied' &&
                                req.qnr?.status != 'new',
                            'hover:bg-gray-200 cursor-pointer':
                                req.status === 'satisfied' ||
                                req.qnr ||
                                req.type === 'verification',
                            'text-blue-400': req.qnr?.status === 'new'
                        }"
                        nz-tooltip
                        [nzMode]="
                            isRequirementsEditMode ? 'closeable' : 'default'
                        "
                        (nzOnClose)="removeRequirement(i)"
                    >
                        {{ req.label }}
                        <i
                            class="fa-solid fa-circle-check"
                            *ngIf="req.status === 'satisfied'"
                        ></i>
                        <i
                            class="fa-solid fa-circle-xmark"
                            *ngIf="req.status === 'not_satisfied'"
                        ></i>
                    </nz-tag>
                </div>

                <!-- Requirements Dropdown -->
                <div
                    class="mt-4 flex items-center"
                    *ngIf="isRequirementsEditMode"
                >
                    <nz-select
                        [(ngModel)]="selectedReq"
                        [ngModelOptions]="{ standalone: true }"
                        nzMode="multiple"
                        placeholder="Select a requirement"
                        class="mr-2"
                        style="min-width: 250px"
                    >
                        <nz-option
                            *ngFor="let q of availableQs"
                            [nzLabel]="q.name"
                            [nzValue]="q"
                        ></nz-option>
                    </nz-select>
                    <button
                        nz-button
                        nzType="primary"
                        (click)="addRequirements()"
                        [disabled]="!selectedReq"
                    >
                        Add Requirement(s)
                    </button>
                </div>
            </section>

            <section *ngIf="order?._id">
                <portals-emr-notes-list
                    [order]="order"
                    label="Notes"
                ></portals-emr-notes-list>
            </section>

            <section *ngIf="prescriptionsLoaded">
                <div class="flex justify-between">
                    <div class="flex items-center">
                        <h5 *ngIf="prescriptionsLoadedType === 'fulfilled'">
                            Fulfilled Prescriptions
                        </h5>
                        <h5 *ngIf="prescriptionsLoadedType === 'related'">
                            Related Prescriptions for Order Products
                        </h5>
                        <!-- Should be no rxs if type OTC, but just in case -->
                        <h5 *ngIf="prescriptionsLoadedType === 'otc'">
                            Prescriptions
                        </h5>
                        <h5 *ngIf="prescriptionsLoadedType === 'v1'">
                            Prescriptions from the last year
                        </h5>
                        <i
                            class="fa-regular fa-circle-question ml-1"
                            nz-tooltip
                            nzTooltipTitle="Shows prescriptions from this order if fulfilled; otherwise, prescriptions with drugs related to order products."
                        ></i>
                    </div>
                    <div class="flex flex-row gap-2">
                        <button
                            data-cy="cy-button-fulfill-order"
                            nz-button
                            nzSize="small"
                            nzType="primary"
                            (click)="openPrescriptionsListDrawer()"
                        >
                            Fulfill Order
                        </button>
                        <button
                            data-cy="cy-button-create-rx-open"
                            nz-button
                            nzSize="small"
                            nzType="primary"
                            (click)="openCreateRx(false)"
                        >
                            Write RX
                        </button>
                        <button
                            data-cy="cy-button-create-rx-open"
                            nz-button
                            nzSize="small"
                            nzType="primary"
                            (click)="openCreateRx(true)"
                            nz-tooltip
                            nzTooltipTitle="Create + Send Rx to fulfillment"
                        >
                            Write Rx + Fulfill Order
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="prescriptionsLoaded">
                    <my-health-admin-order-prescriptions />
                </ng-container>
            </section>

            <section *ngIf="showUnfulfilledOrders">
                <portals-emr-customer-unfulfilled-orders
                    [customerId]="order?.customer?._id"
                    [orderId]="orderId"
                    (showUnfulfilledOrders)="showUnfulfilledOrders = $event"
                />
            </section>

            <!-- ORDER EXTRAS-->
            <section class="text-sm" *ngIf="order?._id">
                <div class="flex flex-row">
                    <h5>Extras</h5>
                    <div class="w-full text-right">
                        <button
                            *ngIf="!isExtrasEditMode; else extrasEditCtrls"
                            nz-button
                            nzType="link"
                            (click)="editExtras()"
                        >
                            <i class="fa-solid fa-pen-to-square"></i>
                        </button>

                        <ng-template #extrasEditCtrls>
                            <button
                                nz-button
                                nzType="link"
                                (click)="isExtrasEditMode = false"
                                Cancel
                            >
                                <i class="fa-solid fa-x"></i>
                            </button>
                            <button
                                nz-button
                                [nzType]="'primary'"
                                (click)="saveExtras()"
                            >
                                <i class="fa-solid fa-check"></i>&nbsp;Save
                            </button>
                        </ng-template>
                    </div>
                </div>

                <div class="flex flex-row flex-wrap">
                    <div
                        (click)="copyToBin(order?._id)"
                        nz-tooltip="Copy value"
                        class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1 cursor-pointer hover:bg-gray-50"
                    >
                        <span class="font-bold">_id: </span>
                        <span>{{ order?._id }}</span>
                    </div>
                    <div
                        (click)="copyToBin(order?.createdAt)"
                        nz-tooltip="Copy value"
                        class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1 cursor-pointer hover:bg-gray-50"
                    >
                        <span class="font-bold">created: </span>
                        <span>{{ order?.createdAt | date : 'medium' }}</span>
                    </div>
                    <div class="px-3 py-1 bg-white rounded-md m-1">
                        <span class="font-bold">source: </span>
                        <span>{{ order?.source }}</span>
                    </div>
                    <div class="px-3 py-1 bg-white rounded-md m-1">
                        <span class="font-bold">Invoices: </span>
                        <span>{{ getInvoicesIds() }}</span>
                    </div>
                    <div
                        class="px-3 py-1 bg-white rounded-md m-1"
                        *ngFor="let meta of order?.meta | keyvalue"
                    >
                        <span class="font-bold">{{ meta.key }}:&nbsp;</span>
                        <span>{{ meta.value }}</span>
                    </div>
                    <ng-container
                        *ngIf="!isExtrasEditMode; else extrasEditModeTpl"
                    >
                        <div
                            (click)="
                                copyToBin(displayExtra(extra.key, extra.value))
                            "
                            class="px-3 py-1 bg-white rounded-md m-1 flex items-center gap-1 cursor-pointer hover:bg-gray-50"
                            *ngFor="let extra of filteredOrderExtrasEntries"
                            nz-tooltip="Copy value"
                        >
                            <span class="font-bold"
                                >{{ extra.key }}:&nbsp;</span
                            >
                            <span>{{
                                displayExtra(extra.key, extra.value)
                            }}</span>
                        </div>
                    </ng-container>
                    <ng-template #extrasEditModeTpl>
                        <div *ngFor="let field of extrasUpdates; index as i">
                            <div class="ml-1 mt-1 flex flex-row">
                                <input
                                    type="text"
                                    nz-input
                                    placeholder="Key"
                                    class="rounded-none"
                                    [(ngModel)]="field[0]"
                                    [ngModelOptions]="{ standalone: true }"
                                />
                                <input
                                    type="text"
                                    nz-input
                                    placeholder="Value"
                                    class="rounded-none"
                                    [(ngModel)]="field[1]"
                                    [ngModelOptions]="{ standalone: true }"
                                />
                                <button
                                    nz-button
                                    nzType="default"
                                    class="rounded-none text-red-400"
                                    (click)="removeExtraField(field)"
                                >
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </div>
                        </div>
                        <button
                            nz-button
                            nzType="link"
                            (click)="addExtraField()"
                            Cancel
                        >
                            <i class="fa-solid fa-plus"></i>&nbsp;Add
                        </button>
                    </ng-template>
                </div>
            </section>
            <div
                *ngIf="
                    order?.createdBy ||
                    order?.statusHistory?.length ||
                    order?.failedWorkflowRuns?.length
                "
            >
                <nz-divider
                    nzText="Status History"
                    nzOrientation="left"
                ></nz-divider>
                <nz-timeline nzMode="left">
                    <nz-timeline-item
                        *ngIf="order.createdBy"
                        [nzLabel]="order?.createdAt | date : 'MMM d, y, h:mm a'"
                    >
                        <nz-tag>Created By:</nz-tag>
                        <nz-tag
                            *ngTemplateOutlet="
                                userName;
                                context: {
                                    $implicit:
                                        order?.createdBy | userDetails | async
                                }
                            "
                        >
                        </nz-tag>
                    </nz-timeline-item>
                    <nz-timeline-item
                        *ngIf="order?.statusHistory?.length"
                        [nzLabel]="order.createdAt | date : 'MMM d, y, h:mm a'"
                    >
                        <nz-tag
                            >{{
                                orderStatuses[order.statusHistory[0].prevStatus]
                            }}
                        </nz-tag>
                    </nz-timeline-item>
                    <ng-container
                        *ngFor="let entry of statusTimelineEntries"
                    >
                        <nz-timeline-item
                            *ngIf="entry.kind === 'status'"
                            [nzLabel]="entry.time | date : 'MMM d, y, h:mm a'"
                        >
                            <nz-tag
                                >{{ orderStatuses[entry.newStatus] }}
                            </nz-tag>
                            <ng-container
                                *ngTemplateOutlet="
                                    userName;
                                    context: {
                                        $implicit:
                                            entry.userId | userDetails | async
                                    }
                                "
                            >
                            </ng-container>
                        </nz-timeline-item>
                        <nz-timeline-item
                            *ngIf="entry.kind === 'failed'"
                            [nzLabel]="entry.time | date : 'MMM d, y, h:mm a'"
                            [nzColor]="entry.reran ? 'blue' : 'red'"
                        >
                            <span
                                class="failed-workflow-runs__node"
                                role="button"
                                tabindex="0"
                                (click)="
                                    openFailedRunsDrawer(entry.runs, entry.time)
                                "
                                (keydown.enter)="
                                    openFailedRunsDrawer(entry.runs, entry.time)
                                "
                            >
                                <nz-tag
                                    [nzColor]="entry.reran ? 'blue' : 'red'"
                                    class="failed-workflow-runs__tag"
                                >
                                    <i
                                        [class]="
                                            entry.reran
                                                ? 'fa-solid fa-rotate-right'
                                                : 'fa-solid fa-circle-xmark'
                                        "
                                        aria-hidden="true"
                                    ></i>
                                    {{ entry.runs[0].workflowName }}
                                </nz-tag>
                                <nz-tag
                                    *ngIf="entry.runs.length > 1"
                                    [nzColor]="entry.reran ? 'blue' : 'red'"
                                >
                                    +{{ entry.runs.length - 1 }}
                                </nz-tag>
                            </span>
                        </nz-timeline-item>
                    </ng-container>
                </nz-timeline>
            </div>
        </nz-content>

        <nz-footer class="bg-transparent">
            <h5 *ngIf="error" class="text-orange-600">ERROR: {{ error }}</h5>
            <h5 *ngIf="!!order && !order?._id">
                Legacy orders are not fully supported; Only orders created after
                March 5th, 2024 are fully supported.
            </h5>
        </nz-footer>
    </nz-spin>
</nz-layout>

<!-- Failed Workflow Runs list drawer -->
<nz-drawer
    [nzVisible]="failedRunsDrawerVisible"
    [nzWidth]="420"
    nzTitle="Failed Workflow Runs"
    (nzOnClose)="closeFailedRunsDrawer()"
>
    <ng-container *nzDrawerContent>
        <p
            *ngIf="selectedFailedRunsTime"
            class="failed-workflow-runs__drawer-time"
        >
            {{ selectedFailedRunsTime | date : 'MMM d, y, h:mm a' }}
        </p>
        <div
            *ngFor="let run of selectedFailedRuns"
            class="failed-workflow-runs__drawer-item"
            role="button"
            tabindex="0"
            nz-tooltip
            nzTooltipTitle="View workflow run details"
            (click)="openRunDetail(run)"
            (keydown.enter)="openRunDetail(run)"
        >
            <div class="failed-workflow-runs__item-main">
                <div class="failed-workflow-runs__item-header">
                    <nz-tag>{{ run.workflowName }}</nz-tag>
                    <nz-tag *ngIf="run.reranAt" nzColor="blue">Reran</nz-tag>
                    <span class="failed-workflow-runs__item-meta">
                        {{ run.triggerEvent }}
                    </span>
                </div>
                <p
                    *ngIf="summarizeRunError(run.error)"
                    class="failed-workflow-runs__item-error"
                >
                    {{ summarizeRunError(run.error) }}
                </p>
            </div>
            <i
                class="fa-solid fa-chevron-right failed-workflow-runs__item-chevron"
                aria-hidden="true"
            ></i>
        </div>
    </ng-container>
</nz-drawer>

<!-- Workflow Run Details drawer -->
<portals-emr-workflow-run-detail-drawer
    [(visible)]="workflowRunDetailDrawerVisible"
    [workflowRunId]="workflowRunDetailId"
    (reran)="onWorkflowRunReran($event)"
></portals-emr-workflow-run-detail-drawer>

<!-- Total Amount Change Modal -->
<nz-modal
    [(nzVisible)]="showTotalAmountModal"
    nzTitle="Total Amount Changed"
    (nzOnCancel)="showTotalAmountModal = false"
    (nzOnOk)="confirmSave()"
    nzOkText="Yes, Save Changes"
    nzCancelText="Cancel"
>
    <div *nzModalContent>
        <!-- You can fill in the content here -->
        <p>
            Updating the total does not charge or refund the patient
            automatically. If payment has not yet been captured (delayed
            capture / pay later), the new total — or remaining balance for
            partial pay later — will be used when charging.
        </p>
        <p>Do you want to proceed?</p>
    </div>
</nz-modal>

<!-- Payment Status Update Modal -->
<portals-emr-payment-status-modal
    [(visible)]="showPaymentStatusModal"
    [order]="order"
    [orderId]="orderId"
    [currentPaymentStatus]="paymentStatus"
></portals-emr-payment-status-modal>
<nz-modal
    [(nzVisible)]="showLinkPrescriptionModal"
    (nzVisibleChange)="onLinkPrescriptionModalVisibleChange($event)"
    nzTitle="Link Prescription to Order"
    (nzOnCancel)="closeLinkPrescriptionModal()"
    (nzOnOk)="linkSelectedPrescriptionToOrder()"
    nzOkText="Link Prescription"
    nzCancelText="Cancel"
>
    <div *nzModalContent>
        <div class="text-sm mb-2">
            Select a prescription to link to order #{{ orderId }}.
        </div>
        <nz-select
            class="w-full"
            nzPlaceHolder="Select RX to link"
            [(ngModel)]="selectedPrescriptionToLinkId"
        >
            <nz-option
                *ngFor="let rx of availablePrescriptionsToLink"
                [nzLabel]="getPrescriptionLabel(rx)"
                [nzValue]="rx._id"
            ></nz-option>
        </nz-select>
    </div>
</nz-modal>
<ng-template #userName let-user>
    <nz-tag>{{ user?.firstName }} {{ user?.lastName }}</nz-tag>
</ng-template>
<ng-template #addressTpl let-address>
    <portals-emr-address-display [address]="address" />
</ng-template>
